const images = {
  defaultBackground: require('../assets/images/defaultBackground.png'),
  headerLogo: require('../assets/images/headerLogo.png'),
  supporIco: require('../assets/images/support.png'),
  house: require('../assets/images/house.png'),
  houseActive: require('../assets/images/house-green.png'),
  carIco: require('../assets/images/car.png'),
  qrIcon: require('../assets/images/qrIcon.png'),
  wpnaBuildLogo: require('../assets/images/wpna-build-logo.png'),
  wpPIcon: require('../assets/images/wordpress-plugin-icon.png'),
  scanQrIcon: require('../assets/images/scan-qr-icon.jpeg'),
  qrsettings: require('../assets/images/qrsettings-icon.png'),
  wpnaAndroid: require('../assets/images/wpna-android.png'),
  whiteLogo: require('../assets/images/whiteLogo.png'),
  clippedLogo: require('../assets/images/clippedLogo.jpg'),
  billing: require('../assets/images/billing.png'),
  account: require('../assets/images/account.png'),
  leftIcon: require('../assets/images/leftIcon.png'),
  rightIcon: require('../assets/images/rightIcon.png'),
  hamburger: require('../assets/images/hamburger.png'),
};

export default images;
